import { PlatformSlug } from 'constants/consts'
import { enabledOn, isFeatureAvailable } from 'platformConfig'

export const CARS_QUESTION_BANKS_CONFIG = enabledOn(PlatformSlug.CARSBooster)
export const CASE_BASED_SCENARIOS_CONFIG = enabledOn(
  PlatformSlug.INBDEBooster,
  PlatformSlug.NBDHEBooster,
  PlatformSlug.NDEBCrusher
)
export const SCENARIOS_QBANKS_CONFIG = enabledOn(PlatformSlug.CasperBooster)

export const isCarsQuestionBanksAvailable = (slug?: PlatformSlug) =>
  isFeatureAvailable(CARS_QUESTION_BANKS_CONFIG, slug)
export const isCaseBasedScenariosAvailable = (slug?: PlatformSlug) =>
  isFeatureAvailable(CASE_BASED_SCENARIOS_CONFIG, slug)
export const isScenariosQBanksAvailable = (slug?: PlatformSlug) => isFeatureAvailable(SCENARIOS_QBANKS_CONFIG, slug)
